<template>
  <div class="collection-page--main-wrapper product-desc">
    <top-header></top-header>

    <div class="collection-page--outer-wrapper mt-65">
      <!--div class="collections-page--header-wrapper">
        <b-container>
          <b-breadcrumb
            :items="breadcrumbItems"
            class="breadcrumb--page"
          ></b-breadcrumb>
          <b-img
            src="../assets/collection-page-cosmetics/collection-page-cosmetics-featured-banner.jpg"
            alt=""
            class="collection-page-feature-banner collection-page-feature-banner--cosmetics"
          ></b-img>
        </b-container>
      </div-->

      <b-container >
        <span class="product-txt d-block text-center" style="padding-top: 50px;">Search Result for : {{this.$route.query.q}}</span>
		<b-container class=" mt-2 py-2 pb-3 filter">
								<b-row class="d-flex align-items-center justify-content-between">
				  <b-col lg="9" md="9" sm="9">
					
					<span>Total items :</span>
					<span class="ml-3">{{totalProduct|0}}</span>
				  
				  </b-col>
				  <b-col class="d-none d-md-block">
					<div class="d-flex align-items-center justify-content-between"	>
					  <span>
					  Sort By:
					</span>
					<span>
					  <b-form-select
						
						class="forms ml-2"
						v-model="sortby"
						:options="optionsSort"
						@change="applyShorting"
					  ></b-form-select>
					  </span>
					</div>
				  </b-col>
				</b-row>

		  </b-container>
        <b-row class="borderTop">
          <b-col cols="12" lg="3" md="3" sm="12" class="filterPael">
            <div class="product-filter--outer-wrapper nav mobilfilter" id="filterlist" :class="[{'mobilfilterlist' : mobilfilterlist}]">
			 <b-container fluid class="d-md-none applyPaneltop">
			  <b-row>
				<b-col cols="6" class="filtebrack">
				<b-link @click="mobilfilterlist=0"><i class="fa fa-angle-left"></i>
				<span>Filters</span></b-link>
				</b-col>
				<b-col class="applyBtn" cols="6">
					<b-link @click="mobilfilterlist=0" class="btnapply"></b-link>
				</b-col>
			   </b-row>
			   </b-container>
              <div class="product-filter--accordion-wrapper accordion" role="tablist">
                <div v-for="(filterTab, index) in filterTabsOptions" :key="filterTab.label">
                  <div role="tab" @click="filterTab.toggleIcon()">
                    <a href="javascript:void(0)" block
                      class="product-filter--accordion-btn d-flex justify-content-between align-items-center"
                      v-b-toggle="'product-accordion-' + index">
                      <span>{{ filterTab.label }}</span>
                      <svg
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="18px"
                        height="18px"
                        viewBox="0 0 22.354 22.354"
                        style="enable-background: new 0 0 22.354 22.354"
                        xml:space="preserve"
                        class="accordion-active-icon accordion-active-icon--minus"
                        v-if="filterTab.showMinusSign">
                        <g><rect y="8.61" width="22.354" height="5.133" /></g>
                      </svg>
                      <b-icon icon="plus" class="accordion-active-icon" v-if="!filterTab.showMinusSign"></b-icon>
                    </a>
                  </div>

                  <b-collapse :id="'product-accordion-' + index" v-bind:visible="filterTab.isOpened" :accordion="'product-filter-accordion' + index" role="tabpanel">
                    <!--<b-form-group v-if="filterTab.label=='Price'">
                      <range-slider
                        class="slider"
                        :min="filterTab.filterOptions.min"
                        :max="filterTab.filterOptions.max"
                        step="10"
                        v-model="filterTab.selectedOptions" @change="applyFilter()">
                      </range-slider>
                    </b-form-group> -->
                    <b-form-group>
                      <b-form-checkbox-group
                        :id="'product-filter-checkbox-' +filterTab.label.toLowerCase()"
                        v-model="filterTab.selectedOptions"
                        :options="filterTab.filterOptions"
                        :name="'product-filter-checkbox-' +filterTab.label.toLowerCase()"
                        class="d-flex flex-column pl-2 product-filter-checkbox-group"
                        @input="applyFilter()"></b-form-checkbox-group>  
                    </b-form-group>
					
					
					
                  </b-collapse>
                </div>
              </div>
			  <b-container fluid class="d-md-none applyPanel">
			  <b-row>
				<b-col cols="6">
				&nbsp;
				</b-col>
				<b-col class="applyBtn" cols="6">
					<b-link @click="mobilfilterlist=0" class="btnapply">Apply</b-link>
					
				</b-col>
			   </b-row>
			   </b-container>
            </div>
          </b-col>

          <b-col cols="12" lg="9" md="9" sm="12" class="pr-0  pl-0 dividerPlist" style="min-height:500px;" id="infinite-list" >
					<transition name="fade">
				  <div class="loading" v-if="showPreloader">
					<span class="fa fa-spinner fa-spin"></span>
				  </div>
				</transition>
				<div class="all-products--wrapper d-flex flex-wrap justify-content-between" v-if="products.length>0" >
				  <div v-for="product in products" :key="product.id"
					class="product--wrapper d-flex flex-column align-items-center">
					<!--<span class="product-title d-block"><a :href="'/product/'+product.product_id">{{product.title}}</a></span> -->
					<!--<product-offer :offer="true" :product="product"></product-offer>-->
					
					<div class="product--img-wrapper imgcatOrg">
					<b-link v-if="product.product_slug==null"
					:href="'/product/'+product.product_id">
					  <b-img-lazy  v-bind="thumbnailProps" blank-color="#f7f7f7" 
						:src="$root.MEDIAAPI+'toolimage/get_image?size='+phoneImageWidth+'x'+phoneImageHeight+'&src='+product.image"
						:alt="product.title"></b-img-lazy>
					  </b-link>
					  <b-link v-else
					:href="'/'+product.product_slug">
					  <b-img-lazy  v-bind="thumbnailProps" blank-color="#f7f7f7" 
						:src="$root.MEDIAAPI+'toolimage/get_image?size='+phoneImageWidth+'x'+phoneImageHeight+'&src='+product.image"
						:alt="product.title"></b-img-lazy>
					  </b-link>
					</div>
					<!-- <product-offer-20 :offer="true" :product="product"></product-offer-20> -->
					<cateoryimage-slider v-if="product.product_slug==null"   :galleryimages="JSON.parse(product.gallery_images)" :phoneImageWidth="phoneImageWidth" :phoneImageHeight="phoneImageHeight" :product_slug="'/product/'+product.product_id"  class="d-none d-md-block" ></cateoryimage-slider>
					<cateoryimage-slider v-else :galleryimages="JSON.parse(product.gallery_images)" :phoneImageWidth="phoneImageWidth" :phoneImageHeight="phoneImageHeight" :product_slug="'/'+product.product_slug"  class="d-none d-md-block" ></cateoryimage-slider> 
					<addtocart-button :productData="product" :pagecategory="true" class="d-none d-md-block"></addtocart-button>
					
					
					<div class="pl-2 pr-2 w-100 ptitleDetail">
						<h4  class="text-truncate m-0"><b-link :href="'/brand/'+product.brand.replace(/ /g,'-')" >{{product.brand}}</b-link></h4>
						<h5 class="text-truncate m-0"> 
						<b-link v-if="product.product_slug==null" :href="'/product/'+product.product_id" class="product-title text-capitalize">{{product.title}}</b-link>
						<b-link v-else :href="'/'+product.product_slug" class="product-title text-capitalize">{{product.title}}</b-link>
						
						</h5>
					</div>
					
				  
					<product-price :category="true" :product="product"></product-price>
					<!--<product-rating :userrating="product.total_rating"></product-rating> -->
					<product-commision :category="true" :product="product" :myroleId="myroleId"></product-commision>
					<addtocart-button :productData="product" :pagecategory="true" class="d-md-none"></addtocart-button> 
				   
				  </div>
				  
				  <div v-if="products.length%3>0" data-v-eedc78cc="" class=" d-flex flex-column align-items-center" style="width: 255px;">
					</div>
					 <div v-if="products.length%2==0" data-v-eedc78cc="" class=" d-flex flex-column align-items-center" style="width: 255px;">
					</div>
				</div>

				
				 <div class="all-products--wrapper d-flex flex-wrap justify-content-between" v-else>				
					<div class="product--wrapperno d-flex flex-column align-items-center" v-if="showPreloader==false">
					<span class="product-title d-block">Our Product Catalogue is being updated daily. Please check back later.</span>
					</div>
			  </div>

            <!-- <b-button type="button" pill class="btn--load-more" v-if="nextPage" @click="loadMore()">Load More</b-button> -->
			<b-container v-if="thisisweb==1 && totalProduct>0">
						<b-pagination v-model="currentPage" pills :total-rows="totalProduct" size="sm" @change="handlePageChange" align="center" per-page="12" limit="10"></b-pagination>
				</b-container>
          </b-col>
        </b-row>
      </b-container>
    </div>
				<!-- ------------ Filter Footer --------------- -->
		<b-container class="mt-2 d-md-none"></b-container>
		<b-container fluid class="filterTab d-md-none">
		<b-row>
				<b-col 	cols="6" class="p-0 b-r-1px">
					<div class="segment-1">
				<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><defs><filter id="579yu3ce3a" width="105.8%" height="143.8%" x="-2.9%" y="-21.9%" filterUnits="objectBoundingBox"><feOffset dy="-1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"></feGaussianBlur><feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></defs><g fill="none" fill-rule="evenodd" opacity=".54"><g fill="#001325" fill-rule="nonzero"><g filter="url(#579yu3ce3a)" transform="translate(-45 -685) translate(0 672)"><g><g><g><g><path d="M5.05 13.551V2.224c0-.373-.307-.68-.679-.68-.372 0-.68.307-.68.68V13.55l-2.513-2.834c-.272-.271-.68-.307-.95-.069-.272.271-.308.68-.07.95l3.704 4.144c.277.343.97.29 1.188 0v-2.19zM12.074 4.398L8.404.255c-.327-.33-.937-.35-1.221 0V13.74c0 .373.307.68.679.68.372 0 .679-.271.679-.647V2.45l2.514 2.834c.271.271.68.307.95.069.271-.274.307-.683.069-.954z" transform="translate(33 6) translate(12) translate(0 7) translate(6 4)"></path></g></g></g></g></g></g></g></svg> Sort By
					
					</div>
				
				</b-col>
				<b-col cols="6" >
					<div class="segment2">
						
						<b-link @click="mobilfilterlist=1">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><defs><filter id="565v74wosa" width="105.8%" height="143.8%" x="-2.9%" y="-21.9%" filterUnits="objectBoundingBox"><feOffset dy="-1" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset><feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"></feGaussianBlur><feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"></feColorMatrix><feMerge><feMergeNode in="shadowMatrixOuter1"></feMergeNode><feMergeNode in="SourceGraphic"></feMergeNode></feMerge></filter></defs><g fill="none" fill-rule="evenodd" opacity=".54"><g fill="#001325" fill-rule="nonzero"><g filter="url(#565v74wosa)" transform="translate(-207 -685) translate(0 672)"><g><g><g><path d="M18.533 5c.567 0 1.028.46 1.028 1.028 0 .247-.089.485-.25.672l-4.98 5.773v5.193c0 .332-.16.643-.43.836L11.9 19.935c-.462.33-1.104.224-1.435-.237-.125-.175-.192-.384-.192-.599v-6.625l-5.02-5.771c-.372-.429-.327-1.078.101-1.45C5.541 5.09 5.78 5 6.028 5h12.505zm-5.468 7.841h-1.528v5.797l1.528-1.094V12.84zm4.95-6.576H6.548l4.688 5.39h2.127l4.65-5.39z" transform="translate(195 6) translate(12) translate(0 7)"></path></g></g></g></g></g></g></svg>
						Filter </b-link>
						
						</div>
				</b-col>
		</b-row>
		</b-container>
		<!-- --------------------- -->
		<share-popup :cartItems="$root.share.shopshareitems"  :cartData="$root.share.shopshareitems" :cartTotalqty="$root.share.shopshareitems.length" :productAll="$root.share.recommended"></share-popup>
    <!-- <top-footer></top-footer> -->
  </div>
</template>

<script>
import Header from "@/components/header.vue";
//import Footer from "@/components/footer.vue";
//import ProductRating from "@/components/product-rating.vue";
import ProductPrice from "@/components/product-price.vue";
import ProductCommision from "@/components/product-commision.vue";
//import ProductOffer from "@/components/product-offer.vue";
//import ProductOffer20 from "@/components/product-offer-20.vue";
import AddtocartButton from "@/components/addtocartButton.vue";
import CateoryimageSlider from "@/components/cateoryimageSlider.vue";
import SharePopup from "@/components/agent/share-popup.vue";
import '../assets/category.scss';

//import RangeSlider from 'vue-range-slider';
// you probably need to import built-in style
import 'vue-range-slider/dist/vue-range-slider.css';
export default {
  name: "collection-page-cosmetics",
  
	props: {
    WEBURL: { type: String },
		metadata: { type: Object },
	},
	
	beforeCreate: function () {
    document.body.className = "collection-page-cosmetics";
  },
  components: {
    "top-header": Header,
    //"top-footer": Footer,
    //"product-rating": ProductRating,
    "product-price": ProductPrice,
	"product-commision": ProductCommision,
	//"product-offer": ProductOffer,
	//"product-offer-20": ProductOffer20,
	"addtocart-button": AddtocartButton,
	"cateoryimage-slider": CateoryimageSlider,
	"share-popup": SharePopup,
    //RangeSlider,
  },
  mounted(){
		//this.initload();
		
		this.loadmoredata();
	  /* ============Sticky LeftPanel===============*/
	  this.$nextTick(function(){
        window.addEventListener("scroll", function(){
          var navbar = document.getElementById("filterlist")
          var nav_classes = navbar.classList
          if(document.documentElement.scrollTop >= 150) {
            if (nav_classes.contains("shrink") === false) {
              nav_classes.toggle("shrink");
            }
			
          }
          else {
            if (nav_classes.contains("shrink") === true) {
              nav_classes.toggle("shrink");
            }
          }
        })
      })
   
	  /*=========================================*/
	  /* =================Device Width =================== */
		if(window.innerWidth < 700){
			window.addEventListener('scroll', this.handleScroll);
			this.thisisweb=0;
			/*this.phoneImageWidth  = 120;
			this.phoneImageHeight = 120;*/
			
		 }
		 
		 
		/* For My account */
	   var roleIdmy =this.$root.customer_info.role;
	   this.myroleId = roleIdmy;
		
	  /* ============= */
	
	},
  data() {
    return {
	mobilfilterlist: 0,
	allowInfinite: true,
	showPreloader: true,
	loading: false,
      heartHover:false,
      nextPage:0,
	  paginationData:[],
	  totalProduct:0,
	  currentPage:0, 
	  thisisweb:1,
      pageurl: this.$root.WEBURL+'searchproducts',
      url: this.$root.WEBURL+'relatedproducts',
      pageinfo: {},
			category_type: '',
			products: [],
      filterQuery: [],
			totalpages:0,
      product_qty:1,
      breadcrumbItems: [
        {
          text: "Home",
          href: "/homepage",
        },
        {
          text: "Cosmetics",
          active: true,
        },
      ],
      priceSliderValue: 0,
      filterTabsOptions: [],
	  thumbnailProps: { blank: false, fluidGrow: true, width: 253, height: 280,class: 'm1' },
	  phoneImageWidth:253,
	  phoneImageHeight:280,
	  myroleId:0,
	optionsSort: [
			{ value: null, text: "Recommended" },
			{ value: 'new', text: "New Arrivals" },
			{ value: "pricedesc", text: "Price: High to Low" },
			{ value: "priceasc", text: "Price: Low to High" },
			{ value: "disconut", text: "Better Discount" },
			{ value: "rating", text: "Customer Rating" },
		  ],
	  sortby:null,
    };
  },

  methods: {
    setData (err, post) {
			if (err) {
				this.error = err.toString()
			} else {
				this.metadata = post
			}
			//console.log(JSON.stringify(post));
		},

		showQuickView(item){
			this.modal_data = Object.assign({}, item);
			this.share_data_qty = 1;
			this.$root.$emit('bv::show::modal', 'qv-modal')
		},

		initload(){
			var self = this;
			self.showPreloader = true;
			var keyword = this.$route.query.q;
			self.axios.post(self.pageurl, {
                accesskey: self.$root.customer_info.access_key,
                keyword: keyword,
                filter:self.filterQuery,
                page:self.nextPage,
				sortby:self.sortby,
			}).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
				  self.filterTabsOptions.length == 0 && self.filters(response.data.result.filter);
				  //console.log(response.data)
				  
				  /* for Pagiation */
					self.nextPage 		= response.data.result.pagination.next;
					self.paginationData = response.data.result.pagination;
					self.currentPage 	= self.paginationData.current>0?self.paginationData.current+1:0;
					self.totalProduct 	= response.data.result.totalProduct;
				
					/* For Web & Mobile View */
					if(self.thisisweb==1){
						self.products=response.data.result.products;
						self.showPreloader = false;
						self.allowInfinite = true;
					
					}else{
						for(let p of response.data.result.products){
							self.products.push(p);
						}
						//console.log("countProduct"+response.data.result.products.length);	
					 if (typeof(self.nextPage)== "undefined"){
							self.showPreloader = false;
							self.allowInfinite = false;
							return;
						}else{
							self.showPreloader = false;
							self.allowInfinite = true;
						}
						
					
					}
				  
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			}).catch(function (error) {
				alert(error);
			});
		},

    filterProductsLoad(){
			var self = this;
      //var keyword = this.$route.query.q;
      self.products = [];
      self.paginationData =[];
	  self.currentPage = 0;
	  self.totalProduct=0;
	  self.nextPage = 0;
	  		  if(self.products.length==0){
				self.allowInfinite= false;
				self.showPreloader= true;
			  }
			  self.initload();
			/* self.axios.post(self.pageurl, {
                accesskey: self.$root.customer_info.access_key,
                keyword: keyword,
                filter: self.filterQuery,
                page:self.nextPage
			}).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					for(let p of response.data.result.products){
					  self.products.push(p);
					}
					self.nextPage = response.data.result.pagination.next;
					if(response.data.result.products.length<9){
						self.showPreloader = false;
						return;
					}
					self.allowInfinite = true;
						
				}else if(response.data.error == 9){
					self.$root.forceLogout(response.data.message);
				}
			}).catch(function (error) {
				alert(error);
			}); */
		},

    loadMore(){
      this.initload();
    },
	loadmoredata(){
      this.initload();
    },
    applyFilter(){
	 this.showPreloader =false;
      this.filterQuery = [];
      for(let filterTab of this.filterTabsOptions){
        //console.log(filterTab.label);
        this.filterQuery.push({[filterTab.label] : filterTab.selectedOptions});
      }
      //console.log(this.filterQuery);
      this.filterProductsLoad();
    },
	filters(filter) {
	  this.filterTabsOptions = [];
	  if(filter.category_filter.length>0){
		var filterOptions = [];

		for(let filter of filter.category_filter){
		  filterOptions.push({ text: filter.title+" ("+filter.count+")", value: filter.id })
		}

		this.filterTabsOptions.push({
		  label: "Category",
		  isOpened: true,
		  showMinusSign: true,
		  this: this,
		  toggleIcon() {
			this.showMinusSign = !this.showMinusSign;
		  },
		  filterOptions: filterOptions,
		  selectedOptions: [],
		});
	  }
	  
	  if(filter.brand_filter.length>0){
		var filterOptionsBrand = [];

		for(let filter of filter.brand_filter){
		  filterOptionsBrand.push({ text: filter.brand+" ("+filter.count+")", value: filter.brand })
		}

			this.filterTabsOptions.push({
			  label: "Brand",
			  isOpened: false,
			  showMinusSign: false,
			  this: this,
			  toggleIcon() {
				this.showMinusSign = !this.showMinusSign;
			  },
			  filterOptions: filterOptionsBrand,
			  selectedOptions: [],
			});
	  } 

	  /*if(filter.price_filter){
		filterOptions = { min: filter.price_filter[0].min, max: filter.price_filter[0].max };
		this.filterTabsOptions.push({
		  label: "Price",
		  isOpened: false,
		  showMinusSign: false,
		  this: this,
		  toggleIcon() {
			this.showMinusSign = !this.showMinusSign;
		  },
		  filterOptions: filterOptions,
		  selectedOptions: '',
		});
	  } */
	  if(filter.price_filter){		
		var filterOptionsPrice = [];
		var filterPF = filter.price_filter[0];
		for(var key in filterPF) {
		  //console.log("Key: " + key + " value: " + filterPF[key]);
		 if(key!='4000 & Above'){
		 var opTextAr = key.split('-');
		 var opText= 'Rs.'+opTextAr[0]+' - Rs.'+opTextAr[1];
		 }else{
		   opText= 'Rs.'+key;
		 }
		 
		 if(filterPF[key]>0){
		  filterOptionsPrice.push({ text: opText+" ("+filterPF[key]+")", value:key});
		  }
		  
		  
		}		
		this.filterTabsOptions.push({
		  label: "Price",
		  isOpened: false,
		  showMinusSign: false,
		  this: this,
		  toggleIcon() {
			this.showMinusSign = !this.showMinusSign;
		  },
		  filterOptions: filterOptionsPrice,
		  selectedOptions: [],
		});
	  }
	  if(filter.discount_filter.length>0){
		var filterOptionsDiscount = [];

		for(let filter of filter.discount_filter){
		  filterOptionsDiscount.push({ text: filter.discount+"% ("+filter.count+")", value: filter.discount})
		}

			this.filterTabsOptions.push({
			  label: "Discount",
			  isOpened: false,
			  showMinusSign: false,
			  this: this,
			  toggleIcon() {
				this.showMinusSign = !this.showMinusSign;
			  },
			  filterOptions: filterOptionsDiscount,
			  selectedOptions: [],
			});
	  }
	  
	  
	  
	  
	  //console.log(this.filterTabsOptions);
	},
	addtofavouriteNotlogin(){
	if(this.$root.customer_info.access_key == ''){
		this.$router.push({
			name: 'Login',
			params: {
				redirect: '/category/'+this.$route.params.category
			}
		});
		}
	},
	handleScroll(event){			
		if (!this.allowInfinite){
			this.showPreloader=false;
			return;
		} 

		//this.showPreloader=true;
		if(!this.showPreloader){
				console.log(event);
				 var listElm = document.getElementById("infinite-list")
				 // console.log(listElm.scrollTop+'---'+listElm.clientHeight+'---'+listElm.scrollHeight);
				  if(listElm.scrollTop + listElm.clientHeight >=listElm.scrollHeight) {
					//var self = this;
					 this.loading = true;
					  setTimeout(this.loadmoredata(),3000);	
						/* setTimeout(e => {
							this.loadmoredata();
							this.showPreloader = false;
						  }, 200); */
					//console.log(e); addEventListener
				  }
			}
		},
		applyShorting() {
			  this.nextPage = 0;
			   this.products = [];
			  this.loadMore();
		 
		},
		handlePageChange(value) {
			//this.page = value;
				console.log('pagNo'+value+'CurretPage:'+this.currentPage);
		  
			  if(this.currentPage!=value){
				  this.nextPage = value-1;
				  this.loadMore();
			  }
		},
		

  },


  metaInfo() {
       // console.log('-------META INFO-------');
		return{
			title: this.metadata.title,
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: this.metadata.keywords },
				{ name: 'description', content: this.metadata.description },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' },
				{ name:'p:domain_verify', content: '2414d644d27428df1547004055b7bcb0' }
			]
		}
	}
};
</script>

<style scoped lang="scss">

</style>